import { useModalStore } from "@/store/modalStore";
import { useUserStore } from "@/store/userStore";
import { MouseEventHandler, useState } from "react";

export const DELETE_USER_IN_STORE_MODAL_NAME = "DeleteUserInStoreModal";

const useDeleteUser = ({
  userId,
  onDeleteUser,
}: {
  userId: number;
  onDeleteUser?: (id: number) => Promise<void>;
}) => {
  const { modals, openModal, closeModal } = useModalStore();
  const [isLoading, setIsLoading] = useState(false);

  const { deleteUser } = useUserStore();

  const handleOpen: MouseEventHandler<HTMLButtonElement | HTMLDivElement> = (
    e,
  ) => {
    e.stopPropagation();
    openModal(DELETE_USER_IN_STORE_MODAL_NAME);
  };

  const handleClose = () => {
    closeModal(DELETE_USER_IN_STORE_MODAL_NAME);
  };

  const handleDelete = async () => {
    setIsLoading(true);

    if (onDeleteUser) {
      await onDeleteUser(userId)
        .then(() => handleClose())
        .finally(() => setIsLoading(false));
    } else {
      await deleteUser(userId)
        .then(() => handleClose())
        .finally(() => setIsLoading(false));
    }
  };

  return {
    handleOpen,
    open: modals[DELETE_USER_IN_STORE_MODAL_NAME],
    handleClose,
    handleDelete,
    isLoading,
  };
};

export { useDeleteUser };
